<template>
  <ul :class="`source ${sourceShow()}`">
    <li class="source__item">
      <label class="source__checkbox">
        <input
          name="postsType"
          type="checkbox"
          value="smi"
          :disabled="disabledCheckBox('smi')"
          v-model="postsType"
          class="visually-hidden"
        >
        <i class="material-icons md-24 color_primary" v-if="isCheck('smi')">check_box</i>
        <i class="material-icons md-24 color_primary" v-else>check_box_outline_blank</i>
        <span class="source__name">сми</span>
      </label>
    </li>
    <li class="source__item">
      <label class="source__checkbox">
        <input
          name="postsType"
          type="checkbox"
          value="soc"
          :disabled="disabledCheckBox('soc')"
          v-model="postsType"
          class="visually-hidden"
        >
        <i class="material-icons md-24 color_primary" v-if="isCheck('soc')">check_box</i>
        <i class="material-icons md-24 color_primary" v-else>check_box_outline_blank</i>
        <span class="source__name">соц. сети</span>
      </label>
    </li>
  </ul>
</template>

<script>
// store
import { POST_TYPE_TO_SHOW } from '../../../../store/actions/posts';

export default {
  name: "Source",
  data() {
    return {
      onRoute: 'threadId',
      postsType: ["smi", "soc"],
      typeCount: 2,
      disabled: {
        smi: false,
        soc: false
      }
    };
  },
  methods: {
    sourceShow() {
      return this.onRoute !== 'threadId' ? 'source--hide' : '';
    },
    disabledCheckBox(type) {
      return this.postsType.length < this.typeCount && this.isCheck(type);
    },
    isCheck(type) {
      return this.postsType.includes(type);
    }
  },
  mounted() {
    this.$store.dispatch(POST_TYPE_TO_SHOW, this.postsType);
    this.onRoute = this.$route.name;
  },
  watch: {
    postsType(val) {
      this.$store.dispatch(POST_TYPE_TO_SHOW, val);
    },
    $route(route){
      this.onRoute = route.name;
    }
  }
};
</script>

<style>
.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  border: 0;
  padding: 0;
  clip: rect(0 0 0 0);
  overflow: hidden;
}

.source {
  display: flex;
  padding: 0;
  margin: 0 33px 0 0;
  font-family: "Oswald", "Arial", sans-serif;
  font-weight: 500;
  color: #000000;
  font-size: 14px;
  line-height: normal;
  text-transform: uppercase;
  cursor: pointer;
  list-style: none;
}

.source__item {
  margin-right: 32px;
}

.source__checkbox {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.source__item:last-child {
  margin: 0;
}

.source__item .material-icons {
  margin-right: 10px;
}

.source--hide {
  opacity: 0;
}

@media (max-width: 1040px) {
  .source--hide {
    opacity: 1;
    display: none;
  }
}

@media (max-width: 760px) {
  .source__item {
    margin-right: 12px;
  }
}
</style>
